import { render, staticRenderFns } from "./smallNav.vue?vue&type=template&id=2bc96264&scoped=true"
import script from "./smallNav.vue?vue&type=script&lang=js"
export * from "./smallNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc96264",
  null
  
)

export default component.exports